import { post, get, put, patch, remove } from "../../ApiService";
import { ApiUrl } from "../../ApiUrl";
import {
  GeneralParams,
  GetEquipmentRegistryListParams,
} from "../EquipmentMaster/types";
import {
  CommonUtil,
  CommonUtilResponse,
  GetCommonUtilListParams,
} from "./types";

export const getCommonUtilList = async (
  params: GetCommonUtilListParams,
  region: number
) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize)
      queryParams.append("pageSize", params.pageSize.toString());
    if (params.orderBy)
      queryParams.append("order_by", params.orderBy.toString());
    if (params.search) queryParams.append("search", params.search);
    if (params.name) queryParams.append("name", params.name);
    if (params.type) queryParams.append("type", params.type);

    const queryString = queryParams.toString();
    const url = `${ApiUrl.commonUtils.commonUtils}${
      queryString ? `?${queryString}` : ""
    }&region=${region}`;

    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getUtilsTypes = async (region: number) => {
  try {
    const url = `${ApiUrl.commonUtils.utilsTypes}?region=${region}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getFilteredCommonUtils = async (type: string, region: number) => {
  try {
    const url = `${ApiUrl.commonUtils.getCommonUtilsByType(
      type
    )}&region=${region}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const createCommonUtil = async (data: CommonUtil, region: number) => {
  try {
    const response = await post(
      `${ApiUrl.commonUtils.commonUtils}?region=${region}`,
      data
    );
    return response;
  } catch (error: any) {
    return error.response;
  }
};

export const getCommonUtilById = async (id: number, region: number) => {
  try {
    const response = await get(
      `${ApiUrl.commonUtils.commonUtils}${id}/?region=${region}`
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateCommonUtil = async (
  id: number,
  data: CommonUtil,
  region: number
) => {
  try {
    const response = await put(
      `${ApiUrl.commonUtils.commonUtils}${id}/?region=${region}`,
      data
    );
    return response;
  } catch (error: any) {
    return error.response;
  }
};

export const partialUpdateCommonUtil = async (
  id: number,
  data: Partial<CommonUtil>,
  region: number
) => {
  try {
    const response = await patch(
      `${ApiUrl.commonUtils.commonUtils}${id}/?region=${region}`,
      data
    );
    return response;
  } catch (error: any) {
    return error.response;
  }
};

export const removeCommonUtil = async (id: number, region: number) => {
  try {
    const response = await remove(
      `${ApiUrl.commonUtils.commonUtils}${id}/?region=${region}`
    );
    return response;
  } catch (error: any) {
    return error.response;
  }
};

export const getActivities = async (region: number) => {
  try {
    const url = `${ApiUrl.commonUtils.activities}?region=${region}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};
